import styled from 'styled-components';

const TotalsText = styled.div`
  color: var(--grey500);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
export default TotalsText;
